const {
  listContextModules
} = require('../utils/loadUtils');

const modulesFiles = require.context('./', true, /\.vue$/); // 排序，xtype的值也是从这里读取


const order = ['text', 'textarea', 'number', 'number-range', 'password', 'radio', 'checkbox', 'select', 'select-multiple', 'select-tree', 'slider', 'switcher', 'time-picker', 'date-picker', 'date-time-picker', 'stepper', 'rate', 'color-picker', 'upload', 'emap-upload'];
export default listContextModules(modulesFiles, order);